<div
  uitoast
  [class]="cssClass"
  (click)="settings()?.clickFn ? settings()!.clickFn!.bind(undefined) : null"
>
  <icon uitoasticon [iconDefinition]="icon"></icon>
  <span
    uitoasttitle
    [innerHTML]="$safeNavigationMigration(settings()?.message)"
  ></span>
  @if (settings()?.pinned) {
    <icon uitoasticon [iconDefinition]="ICONS.CLOSE_SMALL"></icon>
  }
</div>
